import role from './role';

export default {
	rolePage: role
}